import React from 'react'
import { Link } from 'react-router-dom'

const LinkedButton = ({ children, link, target, fontColor }) => {

    return (
        <Link to={link} target={target ? "_blank" : ""} rel={target ? "noopener noreferrer" : ""} className={`w-full h-full flex items-center justify-center text-center py-5 text-xs font-normal font-dmsans leading-[14.40px] ${fontColor}`}>{children} &#8594;</Link>
    )
}

export default LinkedButton
